import { zCompanyFinanceRowDto } from "@/types/company/companyFinance.dto";
import { zCompanyFinanceDom, } from "@/types/company/companyFinance.domain";
export const CompanyFinanceMapper = {
    /** Строка `v_corp_balances` (snake_case) → домен. */
    rowToDomain(raw) {
        const row = zCompanyFinanceRowDto.parse(raw);
        return zCompanyFinanceDom.parse({
            companyId: row.company_id,
            name: row.name,
            status: row.status,
            creditLimit: row.credit_limit,
            billingPeriod: row.billing_period,
            invoiceIssueDay: row.invoice_issue_day,
            paymentTermDays: row.payment_term_days,
            vatRate: row.vat_rate ?? null,
            balance: row.balance,
            availableCredit: row.available_credit,
            totalCharged: row.total_charged,
            totalPaid: row.total_paid,
            openOrdersCount: row.open_orders_count,
            openOrdersExposure: row.open_orders_exposure,
            overdueAmount: row.overdue_amount,
            overdueInvoicesCount: row.overdue_invoices_count,
            lastInvoiceDate: row.last_invoice_date ?? null,
            lastPaymentDate: row.last_payment_date ?? null,
        });
    },
    /** Patch `corp_company_update`: только присутствующие финансовые ключи (camelCase ключи RPC, §4.3). */
    toPatch(patch) {
        return Object.fromEntries(Object.entries(patch).filter((entry) => entry[1] !== undefined));
    },
};
